import { Route } from '@angular/router';

export const complianceRoutes: Route[] = [
  {
    path: 'client-validation',
    loadComponent: () =>
      import(
        './client-validation/client-validation.component'
      ).then((m) => m.ClientValidationComponent),
  },
  {
    path: 'issuing-institutions',
    loadComponent: () =>
      import(
        './issuing-institutions/issuing-institutions.component'
      ).then((m) => m.IssuingInstitutionsComponent),
  },
  {
    path: 'lists',
    loadComponent: () =>
      import('./lists/lists.component').then((m) => m.ListsComponent),
  },
  {
    path: 'entities',
    loadComponent: () =>
      import('./entities/entities.component').then((m) => m.EntitiesComponent),
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./search/search.component').then((m) => m.SearchComponent),
  },
  {
    path: 'client-types',
    loadComponent: () =>
      import('./client-types/client-types.component').then(
        (m) => m.ClientTypesComponent,
      ),
  },
  {
    path: 'client-status',
    loadComponent: () =>
      import('./client-status/client-status.component').then(
        (m) => m.ClientStatusComponent,
      ),
  },
  {
    path: 'thresholds',
    loadComponent: () =>
      import('./thresholds/thresholds.component').then(
        (m) => m.ThresholdsComponent,
      ),
  },
];
